import { useId } from 'react';

import styles from './SwitchRow.module.css';
import type { SwitchRowProps } from './SwitchRow.types';

/** A setting with its words on the left and a switch on the right. The whole switch is one button: Space or Enter flips it. */
export function SwitchRow({ label, hint, checked, onChange, control, 'data-testid': testId }: SwitchRowProps): React.JSX.Element {
  const id = useId();
  return (
    <div className={styles.row}>
      <div className={styles.words}>
        <span id={`${id}-label`} className={styles.label}>
          {label}
        </span>
        <span id={`${id}-hint`} className={styles.hint}>
          {hint}
        </span>
      </div>
      {control}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={`${id}-label`}
        aria-describedby={`${id}-hint`}
        className={styles.switch}
        onClick={() => {
          onChange(!checked);
        }}
        data-testid={testId}
      >
        <span className={styles.track} aria-hidden="true">
          <span className={styles.knob} />
        </span>
      </button>
    </div>
  );
}
